<template>
  <div :class="hostClass">
    <p v-if="!hydrated" :class="$style.message">Loading...</p>
    <ul v-else-if="activities.length" :class="$style.activities">
      <activity
        v-for="activity in activities"
        :activity="activity"
        :key="activity.id"
      />
    </ul>
    <p v-else :class="$style.message">
      Your team have no live calls at the moment.
    </p>
  </div>
</template>

<script>
import axios from "axios";
import Activity from "./activity";
import { createNamespacedHelpers } from "vuex";
import window, { chrome, sessionStorage } from "window";

const { mapState, mapMutations } = createNamespacedHelpers("liveCoach");
const UPDATE_INTERVAL = 15000;

export default {
  components: {
    Activity,
  },
  data() {
    return {
      busy: false,
    };
  },
  computed: {
    ...mapState(["hydrated", "activities"]),
    hostClass() {
      return `host-${this.$_liveCoach_config.hostApp}`;
    },
  },
  created() {
    this.updateActivities();
  },
  beforeDestroy() {
    clearTimeout(this.$_updateTimer);
  },
  methods: {
    ...mapMutations(["setActivities"]),
    updateActivities() {
      if (this.busy) {
        return;
      }

      this.busy = true;
      this.retrieveActivities()
        .then((activities) => {
          this.setActivities(activities);
          this.busy = false;
        })
        .catch((error) => {
          this.busy = false;
          console.log(error);
        });

      this.$_updateTimer = setTimeout(this.updateActivities, UPDATE_INTERVAL);
    },
    retrieveActivities() {
      return axios
        .get(`${this.$_liveCoach_config.jiminnyHost()}/api/v1/activity/live`)
        .then((response) => response.data);
    },
  },
};
</script>

<style module lang="less" src="./live-coach.less"></style>



// WEBPACK FOOTER //
// live-coach.vue?bb0a5c6e